import React from 'react';
import Icon from '../../../components/AppIcon';

const ConfirmationSummary = ({ formData, demoTypes, companySizes, roles }) => {
  const selectedDemoType = demoTypes?.find((t) => t?.value === formData?.demoType);
  const selectedCompanySize = companySizes?.find(
    (s) => s?.value === formData?.companySize
  );
  const selectedRole = roles?.find((r) => r?.value === formData?.role);

  const summaryItems = [
    {
      icon: 'User',
      label: 'Contact Information',
      value: `${formData?.firstName} ${formData?.lastName}\n${formData?.email}\n${formData?.phone}`,
    },
    {
      icon: 'Building2',
      label: 'Company Details',
      value: `${formData?.company}\n${selectedCompanySize?.label || 'Not specified'}`,
    },
    {
      icon: 'Briefcase',
      label: 'Your Role',
      value: selectedRole?.label || 'Not specified',
    },
    {
      icon: 'Monitor',
      label: 'Demo Type',
      value: selectedDemoType?.title || 'Not specified',
    },
    {
      icon: 'Calendar',
      label: 'Preferred Date',
      value: formData?.preferredDate || 'Not specified',
    },
    {
      icon: 'Clock',
      label: 'Preferred Time',
      value: formData?.preferredTime || 'Not specified',
    },
  ];

  return (
    <div className="space-y-4">
      {summaryItems?.map((item, index) => (
        <div
          key={index}
          className="p-4 rounded-lg bg-card border border-border"
        >
          <div className="flex items-start gap-3">
            <div className="p-2 rounded-lg bg-primary/10">
              <Icon name={item?.icon} size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1">
              <div className="text-xs text-muted-foreground mb-1">
                {item?.label}
              </div>
              <div className="text-sm text-foreground font-medium whitespace-pre-line">
                {item?.value}
              </div>
            </div>
          </div>
        </div>
      ))}
      {formData?.additionalInfo && (
        <div className="p-4 rounded-lg bg-card border border-border">
          <div className="flex items-start gap-3">
            <div className="p-2 rounded-lg bg-primary/10">
              <Icon name="MessageSquare" size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1">
              <div className="text-xs text-muted-foreground mb-1">
                Additional Information
              </div>
              <div className="text-sm text-foreground">{formData?.additionalInfo}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfirmationSummary;